import React, { useContext, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { ProductContext } from '../../context/ProductContext';
import { CartContext } from '../../context/CartContext';
import { FaFilter, FaHeart } from 'react-icons/fa';
import './Shop.css';

const ShopPage = () => {
  const [searchParams] = useSearchParams();
  const category = searchParams.get('category');
  const { products, loading } = useContext(ProductContext);
  const { addToCart } = useContext(CartContext);
  const [filter, setFilter] = useState(category || 'all');

  const categories = [
    { id: 'all', name: 'All Collections' },
    { id: 'gold', name: 'Gold Collection' },
    { id: 'silver', name: 'Silver Collection' },
    { id: 'necklace', name: 'Necklaces' },
    { id: 'jhumka', name: 'Jhumka' },
    { id: 'rings', name: 'Rings' }
  ];

  const filteredProducts = filter === 'all' 
    ? products 
    : products.filter(p => p.category === filter);

  if (loading) {
    return <div className="shop-loading">Loading Products...</div>;
  }

  return (
    <div className="shop-page">
      <h1 className="shop-title">Our Collection</h1>
      
      <div className="shop-filters">
        <div className="filter-label">
          <FaFilter /> Categories
        </div>
        <div className="filter-buttons">
          {categories.map((cat) => (
            <button
              key={cat.id}
              className={`filter-btn ${filter === cat.id ? 'active' : ''}`}
              onClick={() => setFilter(cat.id)}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>

      <div className="product-grid">
        {filteredProducts.map((product) => (
          <div key={product.id} className="product-card">
            <Link to={`/product/${product.id}`} className="product-link">
              <div className="product-image">
                <img 
                  src={product.image} 
                  alt={product.name} 
                  className="product-img"
                />
                {product.tag && <span className="product-tag">{product.tag}</span>}
                <button 
                  className="wishlist-btn" 
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    // Add wishlist functionality here
                  }}
                >
                  <FaHeart />
                </button>
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <div className="product-rating">
                  {'★'.repeat(Math.floor(product.rating))}
                  <span className="rating-count">({product.rating})</span>
                </div>
                <p className="product-price">{product.price}</p>
              </div>
            </Link>
            <button 
              className="add-to-cart-btn"
              onClick={() => addToCart(product)}
            >
              Add to Cart
            </button>
          </div>
        ))}
      </div>

      {filteredProducts.length === 0 && (
        <div className="no-products">
          <p>No products found in this category</p>
        </div>
      )}
    </div>
  );
};

export default ShopPage;